import React from "react";

function OutroB({ items = [], info, onNext }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: 14,
          marginTop: 16,
          marginBottom: 32,
          color: "#fff",
        }}
      >
        {info}
      </div>
      <img
        src={"/assets/walkthrough/ECHO.svg"}
        alt="ECHO and ESA Logos"
        style={{
          width: "25%",
          height: "auto",
          display: "block",
        }}
      />
      {/* Scenario box with banner below */}
      <div
        style={{
          width: "90%",
          maxWidth: 800,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            width: "98%",
          }}
        >
          {/* Scenario box as image container */}
          <div
            style={{
              background: "#fff",
              borderRadius: 2,
              padding: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={"/assets/walkthrough/outro2.svg"}
              alt="Scenario Illustration"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
        </div>
        {/* Banner image below scenario box */}
        <img
          src={"/assets/walkthrough/banner_with3d.png"}
          alt="Banner"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            marginBottom: 40,
          }}
        />
      </div>
      <div></div>
    </div>
  );
}

export default OutroB;
